// Property codes reach us from uploaded files and other tools, so the same code shows up
// HTML-encoded (Block Val-d&rsquo;Or), carrying a typographic apostrophe, or plain. They are
// compared decoded and folded, the way ProjectCodeMatcher does on the backend.
const APOSTROPHE_ENTITIES = /&(?:rsquo|rsqo|lsquo|lsqo|apos|#0*39|#x0*27|#0*146|#x0*92|#0*8216|#0*8217|#x0*2018|#x0*2019);/gi;
const APOSTROPHE_CHARS = /[\u2018\u2019\u0091\u0092\u02BC\u00B4`]/g;

const decodeEntities = (value) => {
  if (!value.includes('&') || typeof document === 'undefined') return value;
  // A textarea decodes every entity the browser knows, and never runs what it holds.
  const element = document.createElement('textarea');
  element.innerHTML = value;
  return element.value;
};

const normalizeCode = (code) => {
  if (code === null || code === undefined) return '';
  return decodeEntities(String(code))
    .replace(APOSTROPHE_ENTITIES, "'")
    .replace(APOSTROPHE_CHARS, "'")
    .trim()
    .toLocaleLowerCase();
};

export default {
  isProjectCodeDuplicate: (state) => (code, ownCodes = []) => {
    if (code === null || code === undefined) return false;
    const value = normalizeCode(code);
    const own = ownCodes.map(normalizeCode);
    if (own.includes(value)) return false;
    return state.projectCodes.some(c => normalizeCode(c) === value);
  },
  getProjectByCode: (state) => (code) => {
    const value = normalizeCode(code);
    // A code that normalizes to nothing matches no property.
    if (!value) return undefined;
    return state.projects.find(p => p.codes?.some(c => normalizeCode(c) === value));
  },
  getProjectById: (state) => (projectId) => {
    if (projectId === null || projectId === undefined) return undefined;
    return state.projects.find(p => p.projectId === projectId);
  },
  getProjectHoles: (state, getters) => (code) => {
    if (code !== null && code !== undefined) {
      const project = getters.getProjectByCode(code);
      if (project !== undefined) {
        return state.holes.filter(h => h.projectId === project.projectId);
      }
    }

    return state.holes;
  }
}
